<script>
import baseMixin from '@/mixins/baseMixin'
import CommentList from '@/components/comments/comment-list.vue'
import { mapGetters } from 'vuex'
import CommentModel from '@/models/comments/commentModel'
import DisputeHistoryOriginalBookingTimesCommentModel from '@/models/comments/disputeHistoryOriginalBookingTimesCommentModel'
import CommentType from '@/constants/comments/CommentType'
import dayjs from '@/services/date'
import timesheetMixin from '@/mixins/timesheetMixin'
import { ResolveOperations } from '@/constants/disputes/ResolveOperations'
import DisputeTimesheetDetailsClient from '@/models/disputes/disputeTimesheetDetailsClient'
import DisputeTimesheetDetailsCandidateCommentModel from '@/models/disputes/disputeTimesheetDetailsCandidateCommentModel'
import DisputeDialogBookingHistorySubmissionAlert from './dispute-dialog-booking-history-submission-alert.vue'

export default {
  name: 'DisputeDialogBookingHistory',
  components: { CommentList, DisputeDialogBookingHistorySubmissionAlert },
  mixins: [baseMixin, timesheetMixin],
  computed: {
    ...mapGetters({
      timesheet: 'disputes/activeTimesheet',
      resolveStatus: 'disputes/resolveStatus',
    }),
    compBookingHistoryComments() {
      const comments = []

      const submissionOrderList =
        this.determineMostRecentTimesheetSubmissionOrder(this.timesheet)

      for (const submissionType of submissionOrderList) {
        switch (submissionType) {
          case ResolveOperations.CANDIDATE:
            comments.push(this.generateCandidateCommentModel())
            break
          case ResolveOperations.CLIENT:
            comments.push(this.generateClientCommentModel())
            break
          case ResolveOperations.ORIGINAL:
            comments.push(this.generateOriginalBookingCommentModel())
            break
        }
      }

      return comments
    },
  },
  methods: {
    generateCandidateCommentModel() {
      const comment = new CommentModel({
        id: 1,
        addedBy: this.timesheet.candidate.name,
        dateCreated: dayjs(this.timesheet.candidateTimesheet.submittedDateUtc),
        commentText: JSON.stringify(
          new DisputeTimesheetDetailsCandidateCommentModel({
            ...this.timesheet.candidateTimesheet,
            isTeachStart: this.timesheet.candidate.isTeachStart,
            shouldShowRestBreaksQuestion:
              this.timesheet.shouldShowRestBreaksQuestion,
          })
        ),
        type: CommentType.CustomDisputeResolutionHistoryCandidate,
      })

      return comment
    },
    generateClientCommentModel() {
      const comment = new CommentModel({
        id: 2,
        addedBy: this.timesheet.clientTimesheet.details.contactName,
        dateCreated: dayjs(this.timesheet.clientTimesheet.submittedDateUtc),
        commentText: JSON.stringify(
          new DisputeTimesheetDetailsClient(this.timesheet.clientTimesheet)
        ),
        type: CommentType.CustomDisputeResolutionHistoryClient,
      })

      return comment
    },
    generateOriginalBookingCommentModel() {
      return new CommentModel({
        id: 3,
        addedBy: 'Relief Roster',
        dateCreated: dayjs(this.timesheet.startDate),
        commentText: JSON.stringify(
          new DisputeHistoryOriginalBookingTimesCommentModel({
            startTime: this.timesheet.startTime,
            endTime: this.timesheet.endTime,
            breakMinutes: this.timesheet.breakMinutes,
          })
        ),
        type: CommentType.CustomDisputeResolutionHistoryOriginal,
      })
    },
  },
}
</script>

<template>
  <CommentList
    :title="$t('dispute.history.title')"
    :comments="compBookingHistoryComments"
  >
    <template v-slot:prepend>
      <DisputeDialogBookingHistorySubmissionAlert />
    </template>
  </CommentList>
</template>
